var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
const numberFormat = (value) => typeof value === 'number' ? `repeat(${value}, 1fr)` : value;
const getArea = (areas) => areas.map((area) => `"${area}"`).join(' ');
const GridElement = styled.div `
    display: grid;
    margin: ${(props) => props.margin ? props.theme.paddingsMargins.themeMenuMargin : '0rem 0rem 0rem 0rem'};
    height: ${(props) => props.height};
    width: ${(props) => props.width};
    height: ${({ height = 'auto' }) => height};
    grid-auto-flow: ${(props) => props.flow};
    ${(props) => props.flow.includes('row') &&
    css `
        grid-auto-rows: ${(props) => props.flowSize};
      `}
    ${(props) => props.flow.includes('column') &&
    css `
        grid-auto-columns: ${(props) => props.flowSize};
      `}
    justify-content: ${(props) => props.justifyContent};
    align-content: ${(props) => props.alignContent};
    justify-items: ${(props) => props.justifyItems};
    align-items: ${(props) => props.alignItems};
    ${({ rows }) => rows && `grid-template-rows: ${numberFormat(rows)}`};
    grid-template-columns: ${({ columns = 12 }) => numberFormat(columns)};
    ${(props) => props.gap &&
    css `
        grid-row-gap: ${props.gap};
        grid-column-gap: ${props.gap};
      `};
    ${(props) => props.columnGap &&
    css `
        grid-column-gap: ${props.columnGap};
      `};
    ${(props) => props.rowGap &&
    css `
        grid-row-gap: ${props.rowGap};
      `};
    ${({ areas }) => areas && `grid-template-areas: ${getArea(areas)}`};
    ${props => props.mediaQuery}  
  `;
const Grid = (_a) => {
    var { children, columns, rows, gap, columnGap = '1rem', rowGap = '1rem', height = 'auto', width = 'auto', flow = 'row', flowSize = '20px', areas, justifyContent = 'center', alignContent = 'center', justifyItems = 'center', alignItems = 'center', margin = false } = _a, props = __rest(_a, ["children", "columns", "rows", "gap", "columnGap", "rowGap", "height", "width", "flow", "flowSize", "areas", "justifyContent", "alignContent", "justifyItems", "alignItems", "margin"]);
    return (_jsx(GridElement, Object.assign({ margin: margin, columns: columns, rows: rows, gap: gap, columnGap: columnGap, rowGap: rowGap, width: width, height: height, flowSize: flowSize, flow: flow, areas: areas, justifyContent: justifyContent, alignContent: alignContent, justifyItems: justifyItems, alignItems: alignItems }, props, { children: children })));
};
export default Grid;
